/**
 * COUDRE Theme JavaScript
 */

// ===== TOAST =====
var _loadingToast = null;

function showLoadingToast() {
  var container = document.getElementById('toast-container');
  if (!container) return;
  dismissLoadingToast();
  var el = document.createElement('div');
  el.className = 'toast toast-loading';
  el.innerHTML = '<span class="toast-spinner"></span>';
  container.appendChild(el);
  _loadingToast = el;
  setTimeout(function() { el.classList.add('active'); }, 50);
}

function dismissLoadingToast() {
  if (_loadingToast) {
    _loadingToast.remove();
    _loadingToast = null;
  }
}

function showToast(message) {
  dismissLoadingToast();
  var container = document.getElementById('toast-container');
  if (!container || !message) return;
  var el = document.createElement('div');
  el.className = 'toast';
  el.textContent = message;
  container.appendChild(el);
  setTimeout(function() { el.classList.add('active'); }, 50);
  setTimeout(function() {
    el.classList.remove('active');
    setTimeout(function() { el.remove(); }, 300);
  }, 3000);
}

// ===== NAVBAR =====
(function() {
  var navbar = document.querySelector('.navbar');
  var mobileMenuBtn = document.querySelector('.mobile-menu-btn');
  var mobileMenu = document.querySelector('.mobile-menu');
  var accordionBtns = document.querySelectorAll('.mobile-accordion-btn');
  // Only items with data-menu trigger a dropdown
  var navItems = document.querySelectorAll('.navbar-left li[data-menu]');
  var dropdown = document.querySelector('.nav-dropdown');
  var dropdownInner = document.querySelector('.nav-dropdown-inner');
  var menuWaveCanvas = document.getElementById('menu-wave');
  var activeTimeout = null;
  var currentMenu = null;

  // Hierarchical menu data: each key has by_category and by_collection arrays
  var menuData = window.COUDRE_MENU || {};
  var menuLabels = window.COUDRE_MENU_LABELS || { by_category: 'Par catégorie', by_collection: 'Par collection' };

  function buildColumnHTML(heading, items) {
    if (!items || !items.length) return '';
    var links = items.map(function(item) {
      var badge = item.badge ? '<span class="nav-coming-soon">' + item.badge + '</span>' : '';
      return '<a href="' + item.href + '"><span class="link-text">' + item.label + '</span>' + badge + '</a>';
    }).join('');
    return '<div class="nav-dropdown-column">'
      + '<h3 class="nav-dropdown-column-header">' + heading + '</h3>'
      + links
      + '</div>';
  }

  function buildFlatRowHTML(items) {
    if (!items || !items.length) return '';
    var links = items.map(function(item) {
      return '<a href="' + item.href + '"><span class="link-text">' + item.label + '</span></a>';
    }).join('');
    return '<div class="nav-dropdown-row">' + links + '</div>';
  }

  function openDropdown(menuKey) {
    currentMenu = menuKey;
    var data = menuData[menuKey] || {};

    // Mark the active nav item
    navItems.forEach(function(item) {
      item.classList.remove('active');
      if (item.dataset.menu === menuKey) item.classList.add('active');
    });

    var html;
    if (data.items) {
      // Flat horizontal row (e.g. "À propos de" dropdown)
      html = buildFlatRowHTML(data.items);
    } else {
      // Two-column mega-menu (arts de la table, linge de table)
      html = buildColumnHTML(menuLabels.by_category, data.by_category)
        + buildColumnHTML(menuLabels.by_collection, data.by_collection);
    }
    dropdownInner.innerHTML = html;

    dropdown.classList.add('active');
    dropdown.setAttribute('aria-hidden', 'false');

    // Show and position menu-wave below navbar + dropdown (desktop only)
    if (menuWaveCanvas && window.innerWidth >= 1024) {
      menuWaveCanvas.classList.add('desktop-active');
    }
    updateMenuWavePosition();
  }

  function closeDropdown() {
    dropdown.classList.remove('active');
    dropdown.setAttribute('aria-hidden', 'true');
    navItems.forEach(function(item) { item.classList.remove('active'); });
    currentMenu = null;
    // Reset and hide menu-wave on desktop
    if (menuWaveCanvas) {
      menuWaveCanvas.style.top = '80px';
      menuWaveCanvas.classList.remove('desktop-active');
    }
  }

  function updateMenuWavePosition() {
    if (!menuWaveCanvas || !navbar) return;
    var navbarH = navbar.offsetHeight;
    var dropdownH = dropdown.classList.contains('active') ? (dropdown.offsetHeight || 0) : 0;
    menuWaveCanvas.style.top = (navbarH + dropdownH) + 'px';
  }

  function updateAriaExpanded(menuKey) {
    navItems.forEach(function(li) {
      var trigger = li.querySelector('.nav-menu-trigger');
      if (trigger) {
        trigger.setAttribute('aria-expanded', li.dataset.menu === menuKey ? 'true' : 'false');
      }
    });
  }

  // Attach hover/focus only to items that have data-menu (dropdown items)
  navItems.forEach(function(item) {
    var trigger = item.querySelector('.nav-menu-trigger');

    item.addEventListener('mouseenter', function() {
      clearTimeout(activeTimeout);
      openDropdown(item.dataset.menu);
      updateAriaExpanded(item.dataset.menu);
    });
    item.addEventListener('mouseleave', function() {
      activeTimeout = setTimeout(function() {
        closeDropdown();
        updateAriaExpanded(null);
      }, 300);
    });

    if (trigger) {
      trigger.addEventListener('focus', function() {
        clearTimeout(activeTimeout);
        openDropdown(item.dataset.menu);
        updateAriaExpanded(item.dataset.menu);
      });

      // Tab from trigger → redirect focus into first dropdown link
      trigger.addEventListener('keydown', function(e) {
        if (e.key === 'Tab' && !e.shiftKey && currentMenu) {
          var firstLink = dropdownInner.querySelector('a');
          if (firstLink) {
            e.preventDefault();
            firstLink.focus();
          }
        }
      });
    }
  });

  // Keyboard navigation within dropdown
  if (dropdown) {
    dropdown.addEventListener('keydown', function(e) {
      if (e.key !== 'Tab') return;
      var links = dropdownInner.querySelectorAll('a');
      if (!links.length) return;

      var firstLink = links[0];
      var lastLink = links[links.length - 1];

      if (e.shiftKey && document.activeElement === firstLink) {
        // Shift+Tab from first dropdown link → back to active trigger
        e.preventDefault();
        var activeLi = document.querySelector('.navbar-left li[data-menu].active');
        if (activeLi) {
          var t = activeLi.querySelector('.nav-menu-trigger');
          if (t) t.focus();
        }
      } else if (!e.shiftKey && document.activeElement === lastLink) {
        // Tab from last dropdown link → close dropdown, move to next nav item
        e.preventDefault();
        var activeLi = document.querySelector('.navbar-left li[data-menu].active');
        closeDropdown();
        updateAriaExpanded(null);
        if (activeLi && activeLi.nextElementSibling) {
          var nextTrigger = activeLi.nextElementSibling.querySelector('.nav-menu-trigger')
            || activeLi.nextElementSibling.querySelector('a.label');
          if (nextTrigger) nextTrigger.focus();
        }
      }
    });

    dropdown.addEventListener('focusin', function() {
      clearTimeout(activeTimeout);
    });
    dropdown.addEventListener('focusout', function() {
      activeTimeout = setTimeout(function() {
        closeDropdown();
        updateAriaExpanded(null);
      }, 200);
    });
  }

  // Close dropdown on Escape and return focus to trigger
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && currentMenu) {
      var activeLi = document.querySelector('.navbar-left li[data-menu].active');
      closeDropdown();
      updateAriaExpanded(null);
      if (activeLi) {
        var t = activeLi.querySelector('.nav-menu-trigger');
        if (t) t.focus();
      }
    }
  });

  if (dropdown) {
    dropdown.addEventListener('mouseenter', function() {
      clearTimeout(activeTimeout);
    });
    dropdown.addEventListener('mouseleave', function() {
      activeTimeout = setTimeout(closeDropdown, 300);
    });
  }

  // Mobile menu toggle
  if (mobileMenuBtn && mobileMenu) {
    mobileMenuBtn.addEventListener('click', function() {
      var isOpen = mobileMenu.classList.toggle('open');
      mobileMenuBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      mobileMenu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    });
  }

  // Mobile accordion — use click on the button only, not on its children.
  // Links inside accordion content use native navigation; we must NOT call
  // preventDefault or stopPropagation on link clicks.
  accordionBtns.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      // If the user clicked a link inside the content (shouldn't reach here via
      // btn listener, but guard anyway), let it navigate.
      if (e.target.tagName === 'A') return;

      var target = btn.dataset.target;
      var content = document.getElementById('accordion-' + target);
      if (!content) return;

      var isOpen = content.classList.toggle('open');
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      content.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    });
  });
})();

// ===== LOCALE DETECTION POPUP =====
(function() {
  var STORAGE_KEY = 'coudre_locale_dismissed';
  var overlay = document.getElementById('locale-popup-overlay');
  var popup = document.getElementById('locale-popup');
  if (!overlay || !popup) return;

  var closeBtn = popup.querySelector('.locale-popup-close');
  var langSelect = document.getElementById('locale-popup-language');
  var countrySelect = document.getElementById('locale-popup-country');
  var data = window.COUDRE_LOCALE_DATA;

  function open() {
    overlay.classList.add('active');
    popup.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    overlay.classList.remove('active');
    popup.classList.remove('active');
    document.body.style.overflow = '';
    try { localStorage.setItem(STORAGE_KEY, '1'); } catch(e) {}
  }

  // Detect best language from browser
  function detectLanguage() {
    if (!data || !data.availableLanguages.length) return null;
    var browserLangs = navigator.languages || [navigator.language || ''];
    for (var i = 0; i < browserLangs.length; i++) {
      var code = browserLangs[i].toLowerCase().split('-')[0];
      if (data.availableLanguages.indexOf(code) !== -1) return code;
    }
    return null;
  }

  // Detect best country from browser locale region
  function detectCountry() {
    if (!data || !data.availableCountries.length) return null;
    var browserLangs = navigator.languages || [navigator.language || ''];
    for (var i = 0; i < browserLangs.length; i++) {
      var parts = browserLangs[i].split('-');
      if (parts.length > 1) {
        var region = parts[parts.length - 1].toUpperCase();
        if (data.availableCountries.indexOf(region) !== -1) return region;
      }
    }
    return null;
  }

  // Pre-select detected values
  var detectedLang = detectLanguage();
  var detectedCountry = detectCountry();

  if (langSelect && detectedLang) langSelect.value = detectedLang;
  if (countrySelect && detectedCountry) countrySelect.value = detectedCountry;

  // Show on first visit (not previously dismissed)
  var alreadyDismissed = false;
  try { alreadyDismissed = localStorage.getItem(STORAGE_KEY) === '1'; } catch(e) {}

  if (!alreadyDismissed) {
    open();
  }

  // Event listeners
  if (closeBtn) closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', close);

  // Mark as dismissed on form submit (before page navigates away)
  var form = document.getElementById('locale-popup-form');
  if (form) {
    form.addEventListener('submit', function() {
      try { localStorage.setItem(STORAGE_KEY, '1'); } catch(e) {}
    });
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && popup.classList.contains('active')) close();
  });
})();

// ===== COUNTRY SELECTOR =====
(function() {
  function closeAll() {
    document.querySelectorAll('.country-selector.open').forEach(function(s) {
      s.classList.remove('open');
      s.querySelector('.country-selector-btn').setAttribute('aria-expanded', 'false');
      var search = s.querySelector('.country-selector-search');
      if (search) {
        search.value = '';
        filterOptions(s, '');
      }
    });
  }

  function filterOptions(selector, query) {
    var q = query.toLowerCase().trim();
    selector.querySelectorAll('.country-selector-option').forEach(function(opt) {
      var name = opt.querySelector('.country-option-name').textContent.toLowerCase();
      var currency = opt.querySelector('.country-option-currency').textContent.toLowerCase();
      var match = !q || name.indexOf(q) !== -1 || currency.indexOf(q) !== -1;
      opt.closest('li').hidden = !match;
    });
  }

  document.querySelectorAll('.country-selector').forEach(function(selector) {
    var btn = selector.querySelector('.country-selector-btn');
    var searchInput = selector.querySelector('.country-selector-search');
    if (!btn) return;

    btn.addEventListener('click', function() {
      var isOpen = selector.classList.contains('open');
      closeAll();
      if (!isOpen) {
        selector.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
        if (searchInput) searchInput.focus();
      }
    });

    if (searchInput) {
      searchInput.addEventListener('input', function() {
        filterOptions(selector, searchInput.value);
      });
    }
  });

  // Close on click outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.country-selector')) closeAll();
  });

  // Close on Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      var open = document.querySelector('.country-selector.open');
      if (open) {
        var btn = open.querySelector('.country-selector-btn');
        closeAll();
        btn.focus();
      }
    }
  });
})();

// ===== PRODUCT IMAGE CAROUSEL =====
(function() {
  var carousel = document.querySelector('.product-carousel');
  var prevBtn = document.querySelector('.carousel-prev');
  var nextBtn = document.querySelector('.carousel-next');

  if (!carousel) return;

  if (prevBtn) {
    prevBtn.addEventListener('click', function() {
      carousel.scrollBy({ left: -300, behavior: 'smooth' });
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function() {
      carousel.scrollBy({ left: 300, behavior: 'smooth' });
    });
  }
})();

// ===== PRODUCT PAGE =====
(function() {
  var data = window.COUDRE_PRODUCT;
  if (!data) return;

  var variants = data.variants;
  var optionNames = data.options;
  var mainImg = document.getElementById('product-main-img');
  var thumbnails = document.querySelectorAll('.product-thumbnail');
  var variantInput = document.getElementById('variant-id');
  var addToCartBtn = document.getElementById('add-to-cart-btn');
  var productForm = document.getElementById('product-form');
  var selectedOptions = {};
  // Track the currently matched variant so quantity changes can recalculate
  var currentVariant = null;

  for (var k in data.selectedOptions) {
    selectedOptions[k] = data.selectedOptions[k];
  }

  // Thumbnail click → update main image
  thumbnails.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      if (mainImg) {
        // Clear srcset before swapping src so the browser doesn't ignore the change
        mainImg.removeAttribute('srcset');
        mainImg.src = thumb.dataset.full || thumb.src;
        // Restore a srcset from the thumbnail's data-srcset if available
        var newSrcset = thumb.dataset.srcset;
        if (newSrcset) mainImg.srcset = newSrcset;
      }
      thumbnails.forEach(function(t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    });
    thumb.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        thumb.click();
      }
    });
  });

  // Variant button click → update price, availability, image
  document.querySelectorAll('.variant-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var group = btn.dataset.group;
      document.querySelectorAll('.variant-btn[data-group="' + group + '"]').forEach(function(b) {
        b.classList.remove('active');
      });
      btn.classList.add('active');
      selectedOptions[group] = btn.dataset.value;
      updateVariant();
    });
  });

  // Format a total price in cents using the same display pattern as price_formatted.
  // Replaces the numeric amount in the formatted string to preserve the locale's
  // currency symbol position and decimal/thousands separators (e.g. "65,00 €" vs "€65.00").
  function formatPrice(cents, priceFormatted) {
    // Extract the numeric part: digits, commas, periods (e.g. "65,00" or "65.00")
    var numericMatch = priceFormatted.match(/[\d.,]+/);
    if (!numericMatch) return priceFormatted;

    var originalAmount = numericMatch[0];
    // Detect decimal separator: comma (French) or period (English)
    var isCommaDecimal = originalAmount.indexOf(',') > originalAmount.indexOf('.');

    var total = cents / 100;
    var formatted;
    if (isCommaDecimal) {
      // French format: 65,00 — no thousands separator in Shopify money format
      formatted = total.toFixed(2).replace('.', ',');
    } else {
      // English format: 65.00
      formatted = total.toFixed(2);
    }

    return priceFormatted.replace(originalAmount, formatted);
  }

  // Update the ATC button to show quantity × unit price, preserving the locale format.
  function updateAtcPrice() {
    if (!addToCartBtn || !currentVariant || !currentVariant.available) return;
    var qtyInput = document.getElementById('product-qty-input');
    var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
    var totalCents = currentVariant.price * qty;
    var totalFormatted = formatPrice(totalCents, currentVariant.price_formatted);
    var priceSpan = addToCartBtn.querySelector('.atc-price');
    if (priceSpan) priceSpan.textContent = totalFormatted;
  }

  function updateVariant() {
    var matched = variants.find(function(v) {
      return v.options.every(function(opt, i) {
        return selectedOptions[optionNames[i]] === opt;
      });
    });

    if (!matched) return;

    currentVariant = matched;
    if (variantInput) variantInput.value = matched.id;

    // Update ATC button: label + separator + price, or sold-out text
    if (addToCartBtn) {
      addToCartBtn.disabled = !matched.available;
      if (matched.available) {
        var qtyInput = document.getElementById('product-qty-input');
        var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
        var totalFormatted = formatPrice(matched.price * qty, matched.price_formatted);
        addToCartBtn.innerHTML =
          '<span class="atc-label">' + data.addToCartText + '</span>' +
          '<span class="atc-separator" aria-hidden="true"> — </span>' +
          '<span class="atc-price">' + totalFormatted + '</span>';
      } else {
        addToCartBtn.innerHTML = '<span class="atc-label">' + data.soldOutText + '</span>';
      }
    }

    // Image handling with smart color fallbacks and robust thumbnail matching
    var imageUrl = matched.featured_image;
    var imageSrcset = matched.featured_image_srcset;

    if (matched.id === data.defaultVariantId && !matched.featured_image) {
      imageUrl = data.defaultProductImage;
      imageSrcset = data.defaultProductImageSrcset;
    }

    if (!imageUrl && optionNames) {
      // Look for color option index
      var colorIdx = optionNames.findIndex(function(name) {
        var n = name.toLowerCase();
        return n === 'color' || n === 'couleur';
      });
      if (colorIdx !== -1) {
        var colorVal = selectedOptions[optionNames[colorIdx]];
        var siblingVariant = variants.find(function(v) {
          return v.options[colorIdx] === colorVal && v.featured_image;
        });
        if (siblingVariant) {
          imageUrl = siblingVariant.featured_image;
          imageSrcset = siblingVariant.featured_image_srcset;
        }
      }
    }

    if (imageUrl && mainImg) {
      // Clear srcset before swapping src (browser will otherwise ignore src change)
      mainImg.removeAttribute('srcset');
      mainImg.src = imageUrl;
      // Restore a srcset for the new image if available
      if (imageSrcset) {
        mainImg.srcset = imageSrcset;
      }
      
      // Helper to strip Shopify size suffixes for robust URL matching
      var cleanUrl = function(url) {
        if (!url) return '';
        var path = url.split('?')[0].split('#')[0];
        return path.replace(/_(?:[0-9]+x[0-9]*|[0-9]*x[0-9]+|[0-9]+x|pico|icon|thumb|small|compact|medium|large|grande)(?=\.[a-zA-Z0-9]+$)/, '');
      };

      // Sync active thumbnail to match the variant image
      var cleanTarget = cleanUrl(imageUrl);
      thumbnails.forEach(function(t) {
        var tFull = t.dataset.full || t.src;
        if (cleanUrl(tFull) === cleanTarget) {
          thumbnails.forEach(function(t2) { t2.classList.remove('active'); });
          t.classList.add('active');
        }
      });
    }
  }

  // Product quantity +/- controls
  var productQty = document.querySelector('.product-qty');
  if (productQty) {
    productQty.addEventListener('click', function(e) {
      var btn = e.target.closest('.product-qty-btn');
      if (!btn) return;
      var input = document.getElementById('product-qty-input');
      if (!input) return;
      var val = parseInt(input.value, 10) || 1;
      input.value = btn.dataset.action === 'increase' ? val + 1 : Math.max(1, val - 1);
      // Recalculate ATC button price for the new quantity
      updateAtcPrice();
    });
  }

  // Intercept form submit for AJAX cart
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      if (window.COUDRE_CART && variantInput) {
        e.preventDefault();
        var qtyInput = document.getElementById('product-qty-input');
        var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        window.COUDRE_CART.addToCart(parseInt(variantInput.value, 10), qty);
      }
    });
  }
})();

// ===== CART DRAWER =====
(function() {
  var rootUrl = (window.COUDRE_ROUTES && window.COUDRE_ROUTES.rootUrl) || '/';
  if (rootUrl.charAt(rootUrl.length - 1) !== '/') rootUrl += '/';
  var cartBtn = document.querySelector('.cart-btn');
  var cartDrawer = document.getElementById('cart-drawer');
  var cartOverlay = document.getElementById('cart-overlay');
  var debounceTimer = null;

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('open');
    if (cartOverlay) cartOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('open');
    if (cartOverlay) cartOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  // POST with bundled section rendering — one request returns cart data + re-rendered section HTML
  function cartFetch(url, body) {
    body.sections = 'cart-drawer';
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function(r) { return r.json(); });
  }

  function applySectionHTML(response) {
    var html = response.sections && response.sections['cart-drawer'];
    if (!html) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var newContent = tmp.querySelector('#cart-drawer-content');
    var currentContent = document.getElementById('cart-drawer-content');
    if (newContent && currentContent) {
      currentContent.innerHTML = newContent.innerHTML;
    }
    // Read cart count from data attribute on the refreshed section
    var countEl = tmp.querySelector('[data-cart-count]');
    if (countEl) {
      updateCartCount(parseInt(countEl.dataset.cartCount, 10));
    }
  }

  function updateCartCount(count) {
    var badge = document.querySelector('.cart-count');
    if (badge) {
      badge.textContent = count;
      badge.style.display = count > 0 ? 'flex' : 'none';
    }
    var liveRegion = document.querySelector('.cart-count-live');
    if (liveRegion) {
      liveRegion.textContent = count > 0 ? count : '';
    }
  }

  function addToCart(variantId, qty) {
    openCart();
    showLoadingToast();
    return cartFetch(rootUrl + 'cart/add.js', { items: [{ id: variantId, quantity: qty || 1 }] })
      .then(function(response) {
        applySectionHTML(response);
        showToast(window.COUDRE_TOAST && window.COUDRE_TOAST.added);
      });
  }

  function changeQuantity(key, qty) {
    showLoadingToast();
    return cartFetch(rootUrl + 'cart/change.js', { id: key, quantity: qty })
      .then(function(response) {
        applySectionHTML(response);
        if (window.COUDRE_TOAST) {
          showToast(qty === 0 ? window.COUDRE_TOAST.removed : window.COUDRE_TOAST.updated);
        }
      });
  }

  // Event delegation on the drawer — survives innerHTML replacement
  if (cartDrawer) {
    cartDrawer.addEventListener('click', function(e) {
      if (e.target.closest('.cart-close')) {
        closeCart();
        return;
      }

      var qtyBtn = e.target.closest('.cart-qty-btn');
      if (qtyBtn) {
        clearTimeout(debounceTimer);
        var key = qtyBtn.dataset.key;
        var action = qtyBtn.dataset.action;
        var item = qtyBtn.closest('.cart-item');
        var qtyEl = item ? item.querySelector('.cart-qty-value') : null;
        var currentQty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
        var newQty = action === 'increase' ? currentQty + 1 : currentQty - 1;
        if (newQty < 0) newQty = 0;
        debounceTimer = setTimeout(function() {
          changeQuantity(key, newQty);
        }, 300);
        return;
      }

      var removeBtn = e.target.closest('.cart-remove-btn');
      if (removeBtn) {
        changeQuantity(removeBtn.dataset.key, 0);
        return;
      }
    });
  }

  if (cartBtn) cartBtn.addEventListener('click', openCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  window.COUDRE_CART = { addToCart: addToCart, open: openCart };
})();

// ===== SEARCH MODAL =====
(function() {
  var overlay = document.getElementById('search-overlay');
  var modal = document.getElementById('search-modal');
  if (!overlay || !modal) return;

  var input = modal.querySelector('.search-modal-input');
  var resultsContainer = document.getElementById('predictive-search-results-container');
  var viewAllLink = document.getElementById('search-view-all');
  var toggleBtns = document.querySelectorAll('.search-toggle-btn');
  var debounceTimer;
  var ROUTES = window.COUDRE_ROUTES || {};

  function open() {
    overlay.classList.add('active');
    modal.classList.add('active');
    document.body.style.overflow = 'hidden';
    input.focus();
  }

  function close() {
    overlay.classList.remove('active');
    modal.classList.remove('active');
    document.body.style.overflow = '';
    input.value = '';
    resultsContainer.innerHTML = '';
    viewAllLink.style.display = 'none';
  }

  function fetchResults(query) {
    var root = ROUTES.rootUrl || '';
    var url = root + '/search/suggest?q=' + encodeURIComponent(query)
      + '&resources[type]=product'
      + '&resources[options][unavailable_products]=hide'
      + '&section_id=predictive-search';

    fetch(url)
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var div = document.createElement('div');
        div.innerHTML = html;
        var results = div.querySelector('#predictive-search-results');
        resultsContainer.innerHTML = results ? results.innerHTML : '';
        viewAllLink.href = root + '/search?q=' + encodeURIComponent(query) + '&type=product';
        viewAllLink.style.display = '';
      })
      .catch(function() {
        resultsContainer.innerHTML = '';
      });
  }

  input.addEventListener('input', function() {
    clearTimeout(debounceTimer);
    var q = input.value.trim();
    if (q.length < 2) {
      resultsContainer.innerHTML = '';
      viewAllLink.style.display = 'none';
      return;
    }
    debounceTimer = setTimeout(function() { fetchResults(q); }, 300);
  });

  modal.querySelector('.search-modal-form').addEventListener('submit', function() {
    close();
  });

  toggleBtns.forEach(function(btn) { btn.addEventListener('click', open); });
  overlay.addEventListener('click', close);
  modal.querySelector('.search-modal-close').addEventListener('click', close);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.classList.contains('active')) close();
  });
})();

/* ───── BACK TO TOP ───── */
(function() {
  var btn = document.getElementById('back-to-top');
  if (!btn) return;
  window.addEventListener('scroll', function() {
    btn.classList.toggle('visible', window.scrollY > 500);
  });
  btn.addEventListener('click', function() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();

/* ───── PHOTO SLIDER ───── */
(function() {
  var section = document.querySelector('.photo-slider');
  if (!section) return;

  var slides = section.querySelectorAll('.photo-slider-slide');
  var dots   = section.querySelectorAll('.photo-slider-dot');
  if (!slides.length) return;

  var speed   = parseInt(section.dataset.speed, 10) || 5000;
  var current = 0;
  var timer   = null;

  function goTo(index) {
    // Deactivate outgoing slide
    slides[current].classList.remove('active');
    slides[current].setAttribute('aria-hidden', 'true');
    if (dots[current]) {
      dots[current].classList.remove('active');
      dots[current].setAttribute('aria-selected', 'false');
    }

    current = (index + slides.length) % slides.length;

    // Activate incoming slide
    slides[current].classList.add('active');
    slides[current].setAttribute('aria-hidden', 'false');
    if (dots[current]) {
      dots[current].classList.add('active');
      dots[current].setAttribute('aria-selected', 'true');
    }
  }

  function next() {
    goTo(current + 1);
  }

  function startAutoplay() {
    timer = setInterval(next, speed);
  }

  function stopAutoplay() {
    clearInterval(timer);
    timer = null;
  }

  // Dot buttons allow manual navigation
  dots.forEach(function(dot) {
    dot.addEventListener('click', function(e) {
      // Prevent bubbling to the section click-to-navigate handler
      e.stopPropagation();
      stopAutoplay();
      goTo(parseInt(dot.dataset.index, 10));
      startAutoplay();
    });
  });

  // Clicking anywhere on the slider navigates to the CTA url
  section.addEventListener('click', function(e) {
    // Let native <a> clicks (the CTA button) handle themselves
    if (e.target.closest('a')) return;
    var url = section.dataset.url;
    if (url) window.location.href = url;
  });

  // Pause autoplay on hover to let users read the image
  section.addEventListener('mouseenter', stopAutoplay);
  section.addEventListener('mouseleave', startAutoplay);

  // Keyboard: left/right arrow keys to navigate while slider is focused
  section.setAttribute('tabindex', '0');
  section.addEventListener('keydown', function(e) {
    if (e.key === 'ArrowLeft')  { stopAutoplay(); goTo(current - 1); startAutoplay(); }
    if (e.key === 'ArrowRight') { stopAutoplay(); goTo(current + 1); startAutoplay(); }
  });

  startAutoplay();
})();

/* ───── SPLIT HERO MOBILE CAROUSEL ───── */
(function() {
  var hero = document.querySelector('.split-hero');
  if (!hero) return;

  var items = hero.querySelectorAll('.split-hero-item');
  var dots  = hero.querySelectorAll('.split-hero-dot');
  if (items.length < 2) return;

  var speed   = parseInt(hero.dataset.speed, 10) || 5000;
  var current = 0;
  var timer   = null;
  var active  = false; // true when carousel mode is running

  function goTo(index) {
    // Lower all items before switching so the incoming slide fades in on top
    items.forEach(function(item) { item.style.zIndex = '0'; });

    items[current].classList.remove('active');
    items[current].setAttribute('aria-hidden', 'true');
    if (dots[current]) {
      dots[current].classList.remove('active');
      dots[current].setAttribute('aria-selected', 'false');
    }

    current = (index + items.length) % items.length;

    // Bring the incoming item to the top before adding .active so it fades in above the outgoing one
    items[current].style.zIndex = '2';
    items[current].classList.add('active');
    items[current].setAttribute('aria-hidden', 'false');
    if (dots[current]) {
      dots[current].classList.add('active');
      dots[current].setAttribute('aria-selected', 'true');
    }
  }

  function next() {
    goTo(current + 1);
  }

  function startAutoplay() {
    if (timer) return;
    timer = setInterval(next, speed);
  }

  function stopAutoplay() {
    clearInterval(timer);
    timer = null;
  }

  function activate() {
    if (active) return;
    active = true;
    // Set the initial active state on slide 0
    current = 0;
    items[0].classList.add('active');
    items[0].setAttribute('aria-hidden', 'false');
    if (dots[0]) {
      dots[0].classList.add('active');
      dots[0].setAttribute('aria-selected', 'true');
    }
    for (var i = 1; i < items.length; i++) {
      items[i].classList.remove('active');
      items[i].setAttribute('aria-hidden', 'true');
    }
    hero.classList.add('split-hero--active');
    startAutoplay();
  }

  function deactivate() {
    if (!active) return;
    active = false;
    hero.classList.remove('split-hero--active');
    stopAutoplay();
    // Remove .active so desktop layout is unaffected
    items.forEach(function(item) {
      item.classList.remove('active');
      item.removeAttribute('aria-hidden');
    });
    dots.forEach(function(dot) {
      dot.classList.remove('active');
      dot.setAttribute('aria-selected', 'false');
    });
    current = 0;
  }

  // Dot buttons
  dots.forEach(function(dot) {
    dot.addEventListener('click', function(e) {
      e.stopPropagation();
      stopAutoplay();
      goTo(parseInt(dot.dataset.index, 10));
      startAutoplay();
    });
  });

  // Touch swipe: horizontal threshold 40px triggers slide change.
  // We never call preventDefault() so taps still navigate via the <a>.
  var touchStartX = 0;
  var touchStartY = 0;
  hero.addEventListener('touchstart', function(e) {
    touchStartX = e.changedTouches[0].clientX;
    touchStartY = e.changedTouches[0].clientY;
  }, { passive: true });

  hero.addEventListener('touchend', function(e) {
    if (!active) return;
    var deltaX = e.changedTouches[0].clientX - touchStartX;
    var deltaY = e.changedTouches[0].clientY - touchStartY;
    // Only treat as horizontal swipe if X movement dominates and exceeds threshold
    if (Math.abs(deltaX) > 40 && Math.abs(deltaX) > Math.abs(deltaY)) {
      stopAutoplay();
      goTo(deltaX < 0 ? current + 1 : current - 1);
      startAutoplay();
    }
  }, { passive: true });

  // IntersectionObserver: pause when hero scrolls out of view
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!active) return;
        if (entry.isIntersecting) {
          startAutoplay();
        } else {
          stopAutoplay();
        }
      });
    }, { threshold: 0.1 });
    observer.observe(hero);
  }

  // MediaQuery handler: only run carousel below 768px
  var mq = window.matchMedia('(max-width: 767px)');

  function onMqChange(e) {
    if (e.matches) {
      activate();
    } else {
      deactivate();
    }
  }

  // Use addEventListener if available (modern), fall back to addListener
  if (mq.addEventListener) {
    mq.addEventListener('change', onMqChange);
  } else {
    mq.addListener(onMqChange);
  }

  // Initialise based on current viewport
  if (mq.matches) {
    activate();
  }
})();

/* ───── PRODUCT RECOMMENDATIONS ───── */
(function() {
  var container = document.querySelector('[data-product-recommendations]');
  if (!container) return;

  var productId = container.dataset.productId;
  var sectionId = container.dataset.sectionId;
  var url = container.dataset.url + '?section_id=' + sectionId + '&product_id=' + productId + '&limit=4';

  fetch(url)
    .then(function(r) { return r.text(); })
    .then(function(html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var fresh = tmp.querySelector('[data-product-recommendations]');
      if (fresh && fresh.innerHTML.trim().length) {
        container.innerHTML = fresh.innerHTML;
      }
    });
})();
